import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '../../../routes';
import styles from './NavBarLink.module.scss';

interface Props {
  path: ROUTES;
  icon?: ReactNode;
  label: string;
}

const NavBarLink = ({ path, icon, label }: Props) => (
  <li>
    <NavLink
      to={path}
      className={({ isActive }) =>
        classNames(styles.container, isActive && styles.activeLink)
      }
    >
      <div />
      <div className={styles.content}>
        <div className={styles.icon}>
          {icon ? icon : <div className={styles.defaultIcon} />}
        </div>
        <div className={styles.label}>{label}</div>
      </div>
      <div className={styles.separator} />
    </NavLink>
  </li>
);

export default NavBarLink;
